
import { isApp } from '../../utils/env';
export default {
  props: {
    file: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '20px',
    },
    height: {
      type: String,
      default: '20px',
    },
  },
  setup(props) {
    return {
      props,
      isApp,
    };
  },
};
